import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  // Confirmed, and NOT what the title rule derives: the reference screenshots
  // for this book's page came from
  // `digitopia.co/impact-labs/ebooks/executives-guide-to-sustainable-leadership/`
  // on 2026-08-28 and carry that address in their filenames, so the real slug
  // drops the leading "the".
  'executives-guide-to-sustainable-leadership',
  'The Executive’s Guide to Sustainable Leadership',
  `${UPLOADS}/2024/11/digitopia-report-sustainable-leadership-web-02-400x400.jpg`,
  {
    confirmed: true,
    download: pdf(
      '396695c4-afaa-464c-9148-89d8044403c2-The Executive_s Guide to Sustainable Leadership.pdf',
    ),
    // Designed as its own written page on 2026-08-28
    // (`content/pages/ebook-executives-guide-to-sustainable-leadership.ts`),
    // so the card goes there and `prerender.tsx` skips it rather than
    // generating this template over the top of it.
    href: '/en/impact-labs/ebooks/executives-guide-to-sustainable-leadership',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 7
